import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { CHANGE_TIPP_TIME_MS } from '../../../utils';

export type TranscriptionProgressTipProps = {
  isMobile: boolean;
};

const TranscriptionProgressTip: React.FC<TranscriptionProgressTipProps> = ({ isMobile }) => {
  const { t } = useTranslation();

  const getRandomTipText: () => string = () => {
    const vals = t(`home.input.tipps`, { returnObjects: true });
    if (Array.isArray(vals)) {
      return vals[Math.floor(Math.random() * vals.length)];
    }
    return t(`home.input.tipps.${Math.floor(Math.random() * 6)}`, { defaultValue: '' });
  };

  const [tip, setTip] = useState(getRandomTipText());

  useEffect(() => {
    setInterval(() => {
      setTip(getRandomTipText());
    }, CHANGE_TIPP_TIME_MS);
  }, []);

  return (
    <Typography
      data-testid="transcription-progress-tip"
      component="div"
      variant={isMobile ? 'subtitle2' : 'subtitle1'}
    >
      {tip}
    </Typography>
  );
};

export default TranscriptionProgressTip;
